import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-route-wise-bill',
  templateUrl: './route-wise-bill.component.html',
  styleUrls: ['./route-wise-bill.component.scss']
})
export class RouteWiseBillComponent implements OnInit {

  route_id: any;
  session_id: any;
  selected_date: any;
  sessions: any;
  products: any;
  report_data: any = null;
  booth_types: string[];
  routes: Object;

  constructor(private http: HttpService, private global: GlobalService) {
    this.global.set_master_page_title = 'Route Gate Pass';
    this.getRoutes();
    this.getSession();
    this.getProducts();
  }

  getRoutes() {
    this.http.getRouteSessionWise().subscribe((data)=> {
      console.log(data);
      this.routes = data;
    })
  }



  getProducts() {
    this.http.getProduct().toPromise().then((data: []) => {
      console.log(data);
      this.products = data;
    }).catch((error) => {
      console.log(error);
    });
  }

  getSession() {
    this.http.getSession().subscribe((data: []) => {
      console.log(data);
      this.sessions = data;
    }, (error) => {
      console.log(error);
    });
  }

  getData(route_code, date, session ) {
    console.log(route_code);
    console.log(date);
    console.log(session);
    this.session_id = session;
    this.selected_date = date
    this.route_id = route_code
    const data_dict = {
      'session_id': this.session_id,
      'selected_date': this.selected_date,
      'route_id': this.route_id
    }
    this.http.serveRouteWiseBusinessSaleReports(data_dict).subscribe((data) => {
      console.log(data);
      this.report_data = data;
      this.booth_types = Object.keys(data['booth_types']);
      console.log(this.booth_types);
    })
  }

  ngOnInit() {
  }

}
